import { Stream } from '@rimbu/stream';
import { EmptyBase } from '@rimbu/collection-types/map-custom';
export class GraphEmptyBase extends EmptyBase {
    get nodeSize() {
        return 0;
    }
    get connectionSize() {
        return 0;
    }
    streamNodes() {
        return Stream.empty();
    }
    streamConnections() {
        return Stream.empty();
    }
    hasNode() {
        return false;
    }
    hasConnection() {
        return false;
    }
    isSink() {
        return false;
    }
    isSource() {
        return false;
    }
    removeNode() {
        return this;
    }
    removeNodes() {
        return this;
    }
    getConnectionStreamFrom() {
        return Stream.empty();
    }
    getConnectionStreamTo() {
        return Stream.empty();
    }
    disconnect() {
        return this;
    }
    disconnectAll() {
        return this;
    }
    removeUnconnectedNodes() {
        return this;
    }
}
//# sourceMappingURL=base.mjs.map